import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import ContentVideoListView from "./list";
import ContentVideoInformationView from "./single";


const ContentVideos = () => {
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens to the changes in location.pathname and with each change:
     * if the url is the same as content.base, then changes it to the blogs.list.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.content.videos.base, exact: true})) {
            history.replace(routes.content.videos.list);
        }
    }, [history, location.pathname])

    return (
        <Switch>
            <Route path={[
                routes.content.videos.base,
                routes.content.videos.list
            ]} exact>
                <ContentVideoListView/>
            </Route>
            <Route path={[
                routes.content.videos.single,
            ]} exact>
                <ContentVideoInformationView/>
            </Route>
        </Switch>
    );
};

export default ContentVideos;
